import { render, staticRenderFns } from "./home1.vue?vue&type=template&id=ac405f74&scoped=true&"
import script from "./home1.vue?vue&type=script&lang=js&"
export * from "./home1.vue?vue&type=script&lang=js&"
import style0 from "./home1.vue?vue&type=style&index=0&id=ac405f74&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac405f74",
  null
  
)

export default component.exports